'use strict';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class ProductAvailability {
    constructor(root) {
        this.root = root;
        if (!this.root) return;
        
        this.openButton = this.root.querySelector("[data-product-availability-open]");
        this.list = this.root.querySelector("[data-product-availability-list]");
        this.closeButtons = this.root.querySelectorAll("[data-product-availability-close]");

        this._opened = false;

        this._init();
    }

    _init() {
        this.openButton.addEventListener("click", this.open.bind(this));
        this.closeButtons.forEach((button) => button.addEventListener("click", this.close.bind(this)));

        this.root.classList.add("is-inited");
    }

    open() {
        this.list.classList.add("is-opened");
        disableBodyScroll();
        this._opened = true;
    }

    close() {
        this.list.classList.remove("is-opened");
        enableBodyScroll();
        this._opened = false;
    }
}
